import React from 'react'
import { Box, useTheme, Typography, Tooltip } from "@mui/material";
import { tokens } from "../../../theme";

// A non-interactive placeholder shown to admins/teachers when fewer modules
// have been created than the course's total class session count.
// It carries NO real event data — it only fills the gap visually.
const EmptyModuleBox = ({ moduleNumber }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box sx={{ mb: "1rem" }}>
            <Tooltip
                title="This session hasn't been created yet. It's a placeholder, not a scheduled class."
                placement="top"
                arrow
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: "1rem",
                        minHeight: "48px",
                        borderRadius: "4px",
                        backgroundColor: colors.primary[750],
                        boxShadow: "0px 0px 1px 2px rgba(0, 0, 0, 0.15)",
                        border: "1px dashed",
                        borderColor: colors.primary[450],
                        opacity: 0.55,
                    }}
                >
                    <Typography color="primary">
                        Class Module {moduleNumber}
                    </Typography>
                    <Typography sx={{ fontStyle: "italic" }}>
                        Not scheduled yet
                    </Typography>
                </Box>
            </Tooltip>
        </Box>
    )
}

export default EmptyModuleBox
